module.exports = __webpack_public_path__ + "static/media/ministere_sports.909da111.png";